<template>
  <div class="headBox">
    <div class="header">
      <div class="content top-header">
        <div class="verticalMiddle">
          欢迎<span style="color: #f89a00; margin: 0 8px; cursor: pointer" @click="$router.push('/personal')" v-if="userName">{{ name }}</span>来到鲜丰汇&nbsp;&nbsp;&nbsp;&nbsp;好物助农 即刻出发！

          <span style="color: #f89a00; margin-left: 25px; cursor: pointer" @click="userName ? logout() : $router.push('/login')">{{ userName ? "退出" : "登录" }}</span>
          <!-- <span
            v-if="!userName"
            style="color: #F89A00; margin-left: 15px; cursor: pointer"
            @click="$router.push('/register')"
            >注册</span
          > -->
        </div>
        <div id="nav">
          <span @click="$router.push('/personal')">采购人中心</span>
          <!-- <span>供应商中心</span> -->
          <span class="smallHover">小程序码<span class="smallImgBox"><img src="../../../static/image/smallCode.jpg" alt="" width="100%" height="100%" class="smallImg" /></span></span>
          <span @click="$router.push('/shopCar')">购物车({{ shopCarNum }})</span>
          <span @click="$router.push('/myCollection')">收藏夹({{ collectNum }})</span>
          <span @click="$router.push('/infoCenter')">资讯中心</span>
          <span @click="visible = true" style="color: #f89a00">区域专属客户经理</span>
          <!-- <span style="color: #f89a00; margin-left: 25px"
            >如有疑问请联系区域客服经理</span 
          >-->
        </div>
      </div>
    </div>
    <div class="content search">
      <div class="logo" @click="$router.push('/index')">
        <img src="/static/image/newLogo.png" />
        <!-- <div class="line"></div>
        <div class="logo-des">
          <p>消费帮促</p>
          <p>采购平台</p>
        </div> -->
        <span>消费帮促采购平台</span>
      </div>
      <div class="search-box">
        <div>
          <img src="../../../static/image/search.svg" alt="" class="search-icon" />
          <input class="search-input" type="text" placeholder="请输入关键字" v-model="title" @keyup.enter="search()" />
          <button type="button" id="test" class="search-button" @click="search()">
            搜索
          </button>
        </div>
        <!-- <div class="search-hot">
          <span>热门搜索：</span>
          <span>大米</span>
        </div> -->
      </div>
      <div class="textBox">
        <span><span style="font-weight: 700">共同支持： </span><span>江苏省委省级机关工委</span></span>
        <span style="margin-left: 85px">江苏省财政厅</span>

        <span style="margin-left: 85px">江苏省总工会</span>
        <!-- <span style="margin-left: 85px">江苏省乡村振兴局</span> -->
      </div>
    </div>
    <!--导航条-->
    <div class="content navbar">
      <div class="category" :style="
          ($route.meta.categoryColor
            ? 'background-color:' + $route.meta.categoryColor
            : '') + (isShow == false ? 'visibility:hidden' : '')
        ">
        <div class="category-title">商品分类</div>
        <div :class="[
            $route.path == '/categoryGoods'
              ? 'category-contentVisible'
              : 'category-content'
          ]">
          <!-- -->
          <template v-for="(item, index) in categoryList">
            <div class="category-item" @click="
                $router.push({
                  path: '/categoryGoods',
                  query: { pcFirstCategoryId:item.id}
                })
              ">
              <img :src="item.iconUrl" />
              <span>{{ item.text }}</span>
            </div>
            <div class="categoryLine" v-if="index != categoryList.length - 1"></div>
          </template>
        </div>
      </div>
      <div class="navbar-items" v-if="allDataObj.promotion && allDataObj.promotion.length > 0">
        <span :class="[
            'navbar-text',
            $route.path == '/index' ? 'navbar-active' : ''
          ]" @click="$router.push('/index')">首页</span>
        <span v-for="(item, index) in allDataObj.promotion" :key="index" :class="[
            'navbar-text',
            $route.fullPath == item.navigateUrl ? 'navbar-active' : ''
          ]" @click="gotoDetails(item.navigateUrl)">{{ item.bannerTitle }}</span>
      </div>
    </div>
    <Dialog :dialogVisible="visible" @closepop="visible = false"> </Dialog>
  </div>
</template>

<script>
import { doPost, doGet } from "../common/HttpHelper.js";
import { httpConfig } from "../common/config.js";
import dialog from "./dialog.vue";

export default {
  props: {
    isShow: {
      type: Boolean, //可指定接收类型，如:Array.
      default: true, //可设置默认值
    },
  },
  name: "topNav",
  components: {
    Dialog: dialog,
  },
  data() {
    return {
      visible: false,
      userName: this.$cookies.get("userInfo")
        ? this.$cookies.get("userInfo").pcAccount
        : "",
      name: this.$cookies.get("userInfo")
        ? this.$cookies.get("userInfo").name
        : "",
      allDataObj: {},
      title: "", //搜索关键字
      shopCarNum: this.$store.state.shopCarNum, //购物车数量
      collectNum: this.$store.state.collectNum, //收藏夹数量
      chooseNav: 0, //选中的navBar
      categoryList: [],
    };
  },
  watch: {
    "$store.state.shopCarNum"() {
      this.shopCarNum = this.$store.state.shopCarNum;
    },
    "$store.state.collectNum"() {
      this.collectNum = this.$store.state.collectNum;
    },
  },
  mounted() {
    this.getShopCar(0); //获取购物车列表
    this.getShopCar(1); //获取收藏夹列表
    this.title = this.$route.query.title ? this.$route.query.title : "";
    let that = this;
    doPost(
      httpConfig.Index.InfoUrl,
      {},
      function (res) {
        that.allDataObj = that.distributeAllData(res);
      },
      function (res) {}
    );
    doGet(
      httpConfig.Category.findCategoriesUrl,
      {},
      function (res) {
        that.categoryList = res.data;
      },
      function (res) {}
    );
  },
  methods: {
    /**
     * 获取购物车和收藏夹
     */
    getShopCar(type) {
      var that = this;
      doGet(
        httpConfig.shopCar.getShopCarUrl,
        {  type },
        function (res) {
          if (res.flag) {
            if (type == 0) {
              that.shopCarNum = 0;
              var shopCar = res.data;
              shopCar.forEach((item) => {
                item.info = JSON.parse(item.info);
                that.shopCarNum += item.info.num; //计算购物车商品总数
              });
            } else {
              that.collectNum = res.data.length;
            }
          }
        },
        function (res) {}
      );
    },
    //解析所有数据
    distributeAllData(res) {
      var newData = {};
      for (var i = 0; i < res.length; i++) {
        newData[res[i].code] = res[i].banners;
      }
      return newData;
    },
    //跳转至商品列表
    gotoDetails(url) {
      this.$router.push(url);
    },
    //搜索
    search() {
      if (this.title.length == 0) {
        this.$router.push({ path: "/category" });
      } else {
        this.$router.push({ path: "/category", query: { title: this.title } });
      }
    },
    //退出登录
    logout() {
      var that = this;
      this.$confirm("确认退出登录？")
        .then((_) => {
          that.$cookies.remove("peopleId");
          // that.$cookies.remove("shopCar");
          // that.$cookies.remove("shopAddress");
          // that.$cookies.remove("collectList");
          that.$cookies.remove("userInfo");
          localStorage.removeItem("xfh_usertoken");
          // sessionStorage.clear();
          location.reload();
        })
        .catch((_) => {});
    },
  },
};
</script>

<style scoped>
.headBox {
  /* height: 236px; */
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  /* border-bottom: 1px solid #F89A00; */
}
.header {
  width: 100%;
  height: 40px;
  background: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 12px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  color: #969696;
}
.top-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}
.smallHover {
  position: relative;
}
.smallHover:hover .smallImgBox {
  display: inline-block;
}
.smallImgBox {
  display: none;
  width: 200px;
  height: 200px;
  position: absolute;
  top: 40px;
  background-color: #fff;
  z-index: 100;
  left: 50%;
  transform: translate(-50%, 0);
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
}
.smallImgBox::before {
  content: "";
  width: 16px;
  height: 10px;
  border-top: 5px solid transparent;
  border-bottom: 5px solid #fff;
  box-sizing: border-box;
  border-right: 8px solid transparent;
  border-left: 8px solid transparent;
  position: absolute;
  left: 50%;
  top: -10px;
  transform: translate(-50%, 0);
}

.content {
  width: 1200px;
}

#nav {
  display: flex;
  height: 100%;
}

#nav > span {
  padding: 0 15px;
  cursor: pointer;
  line-height: 40px;
}

.search {
  margin-top: 28px;
  display: flex;
  align-items: center;
}

.logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* margin-left: 20px; */
  cursor: pointer;
}

.logo img {
  /* width: 77px;
  height: 77px; */
  width: 168px;
  height: 68px;
  margin-bottom: 4px;
}
.line {
  width: 2px;
  height: 39px;
  background-color: #1a7c3d;
}
.logo .logo-des {
  /* margin-left: 12px; */
  margin-left: 17px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.logo > span {
  height: 19px;
  line-height: 19px;
  font-size: 13px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  color: #b8b8b8;
  letter-spacing: 8px;
}
.logo p {
  /* width: 80px; */
  /* height: 20px;
  font-size: 15px;
  font-family: PingFang, PingFang-Bold;
  font-weight: 700;
  color: #07811f;
  letter-spacing: 4px;
  margin: 0; */
  line-height: 28px;
  color: #1a7c3d;
  margin: 0;
  font-size: 22px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
}

.logo p:last-child {
  margin-top: 6px;
}

.search-box {
  display: flex;
  /*align-items: center;*/
  flex-direction: column;
  /* margin-left: 220px; */
  margin-left: 56px;
}

.search-box div {
  position: relative;
}

.search-box .search-input {
  width: 593px;
  height: 47px;
  border: 2px solid #f89a00;
  border-radius: 5px;
  padding-left: 78px;
  outline: none;
  box-sizing: border-box;
}
.search-box .search-input::placeholder {
  color: #d2d2d2;
}
.search-box .search-button {
  width: 86px;
  height: 47px;
  background-color: #f89a00;
  color: white;
  border: 0;
  position: absolute;
  right: 0;
  top: 0px;
  border-radius: 0 5px 5px 0;
  text-align: center;
  font-size: 16px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  cursor: pointer;
}
.search-box .search-icon {
  width: 25px;
  height: 25px;
  position: absolute;
  left: 40px;
  top: 50%;
  transform: translate(0, -50%);
}

.textBox {
  margin-left: auto;
  /* height: 70px; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  color: #33613b;
  font-size: 14px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 400;
}
.textBox > span {
  height: 21px;
  line-height: 21px;
  margin-bottom: 2px;
}
.search-hot {
  margin-top: 10px;
  font-size: 12px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  color: #aaaaaa;
}
.search-hot span {
  margin-right: 15px;
}
.navbar {
  height: 63px;
  /* height: 0; */
  margin-top: 2px;
  display: flex;
  align-items: center;
}

.category {
  width: 107px;
  height: 36px;
  background: #f89a00;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  border-radius: 5px 5px 0 0;
  align-self: flex-end;
}

.category-title {
  font-size: 16px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  color: #ffffff;
}

.category-contentVisible {
  /* padding-top: 1px; */
  width: 1200px;
  height: 145px;
  position: absolute;
  left: 0;
  top: 36px;
  z-index: 9;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(20px);
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  opacity: 0;
  transition: all 0.3s;
}
.category-content {
  width: 1200px;
  height: 145px;
  position: absolute;
  left: 0;
  top: 36px;
  z-index: 9;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(20px);
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  opacity: 0;
  transition: all 0.3s;
  visibility: hidden;
}

.category:hover .category-contentVisible {
  opacity: 1;
}
.category:hover .category-content {
  opacity: 1;
  visibility: visible;
}
.category-item {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color: #333333;
  position: relative;
}
.categoryLine {
  width: 1px;
  height: 47px;
  background-color: #fff;
}
.category-item img {
  width: 65px;
  height: 65px;
  margin-bottom: 5px;
}
.category-item span {
  height: 25px;
  line-height: 25px;
  font-size: 16px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  color: #ffffff;
}

.category-item:hover span {
  color: #f89a00;
}
/* .category-content .category-item {
  margin-bottom: 0.8px;
}

.category-content .category-item:last-child {
  margin: 0;
} */

.navbar-items {
  margin-left: 108px;
  padding-left: 9px;
  display: flex;
}

.navbar-text {
  height: 39px;
  line-height: 39px;
  font-size: 16px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  color: #333333;
  cursor: pointer;
  box-sizing: border-box;
}
.navbar-active {
  color: #f89a00;
  border-bottom: 5px solid #f89a00;
}

.navbar-items :nth-child(n + 2) {
  margin-left: 41px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue